import React from "react";
import i18n from "../../../../i18n/i18n";
import {storesContext} from "../../../../common/stores/stores";
import {ITimetableStore} from "../../../stores/timetableStore";
import TextInput from "../../../../common/components/shared/textInput/textInput";
import DateAndTime from "../dateAndTime/dateAndTime";
import {DropDownUtils} from "../../../../helpers/dropDownUtils";
import MultiSelectDropDown from "../../../../common/components/shared/multiSelectDropDown/multiSelectDropDown";
import DropDown from "../../../../common/components/shared/dropDown/dropDown";
import {DropDownModel} from "../../../../common/models/dropDown";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../common/models/httpError";
import {Api} from "../../../../helpers/api";

interface DepartureActionSectionProps {
    actionIndex: number;
    wharfs: DropDownModel[];
    whrafsResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    whrafsReload: () => void;
    portsResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    portsReload: () => void;
    routesResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    routesReload: () => void;
}

export default class DepartureActionSection extends React.Component<DepartureActionSectionProps> {
    static contextType = storesContext;

    render() {
        const timetableStore = this.context.timetableStore as ITimetableStore;

        return (
            <>
                <div className="section with-border">
                    <TextInput
                        label={i18n.t("timetable.headers.voyageNo")}
                        validatedValue={timetableStore.actions[this.props.actionIndex].voyageNo}
                        testId={`voyage-no-${this.props.actionIndex}`}
                        className="voyageNo"
                        disabled={timetableStore.actions[this.props.actionIndex].hasOrderRegistered}
                    />
                    <DropDown
                        label={i18n.t("timetable.headers.wharf")}
                        validatedValue={timetableStore.actions[this.props.actionIndex].wharfId}
                        items={this.props.wharfs}
                        testId={`wharf-${this.props.actionIndex}`}
                        withoutSort
                        error={!Api.isSuccess(this.props.whrafsResponse) ? i18n.t("errorMessages.whrafsErrorSuffix") : ""}
                        reloadFunc={() => this.props.whrafsReload()}
                    />
                    <TextInput
                        label={i18n.t("timetable.headers.notes")}
                        validatedValue={timetableStore.actions[this.props.actionIndex].notes}
                        testId={`notes-${this.props.actionIndex}`}
                        className="notes"
                        maxLength={150}
                    />
                </div>
                <div className="section">
                    <div className="time-section">
                        <div>
                            <div className="time-header">{i18n.t("timetable.headers.plannedTime")}</div>
                            <DateAndTime
                                testId={`arrival-time-${this.props.actionIndex}`}
                                dateLabel={i18n.t("timetable.headers.arrivalTime")}
                                dateValue={timetableStore.actions[this.props.actionIndex].arrivalDate}
                                onChangeDate={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setArrivalDate(newDate);
                                }}
                                hourValue={timetableStore.actions[this.props.actionIndex].arrivalHour}
                                onChangeHour={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setArrivalHour(newDate);
                                }}
                                disabled={timetableStore.actions[this.props.actionIndex].hasOrderRegistered}
                            />
                            <DateAndTime
                                testId={`departure-time-${this.props.actionIndex}`}
                                dateLabel={i18n.t("timetable.headers.departureTime")}
                                dateValue={timetableStore.actions[this.props.actionIndex].departureDate}
                                onChangeDate={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setDepartureDate(newDate);
                                }}
                                hourValue={timetableStore.actions[this.props.actionIndex].departureHour}
                                onChangeHour={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setDepartureHour(newDate);
                                }}
                                disabled={timetableStore.actions[this.props.actionIndex].hasOrderRegistered}
                            />

                        </div>
                        <div>
                            <div className="time-header">{i18n.t("timetable.headers.actualTime")}</div>
                            <DateAndTime
                                testId={`actual-arrival-time-${this.props.actionIndex}`}
                                dateLabel={i18n.t("timetable.headers.actualArrivalTime")}
                                dateValue={timetableStore.actions[this.props.actionIndex].actualArrivalDate}
                                onChangeDate={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setActualArrivalDate(newDate);
                                }}
                                hourValue={timetableStore.actions[this.props.actionIndex].actualArrivalHour}
                                onChangeHour={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setActualArrivalHour(newDate);
                                }}
                            />

                            <DateAndTime
                                testId={`actual-departure-time-${this.props.actionIndex}`}
                                dateLabel={i18n.t("timetable.headers.actualDepartureTime")}
                                dateValue={timetableStore.actions[this.props.actionIndex].actualDepartureDate}
                                onChangeDate={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setActualDepartureDate(newDate);
                                }}
                                hourValue={timetableStore.actions[this.props.actionIndex].actualDepartureHour}
                                onChangeHour={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setActualDepartureHour(newDate);
                                }}
                            />
                        </div>
                        <div>
                            <div className="time-header">{i18n.t("timetable.headers.routeAndLoading")}</div>
                            <MultiSelectDropDown
                                label={i18n.t("timetable.headers.route")}
                                validatedValue={timetableStore.actions[this.props.actionIndex].routes}
                                items={this.routesToDropDownMap()}
                                className="route"
                                testId={`route-${this.props.actionIndex}`}
                                error={!Api.isSuccess(this.props.routesResponse) ? i18n.t("errorMessages.routesErrorSuffix") : ""}
                                reloadFunc={() => this.props.routesReload()}
                            />
                            <DateAndTime
                                testId={`start-loading-time-${this.props.actionIndex}`}
                                dateLabel={i18n.t("timetable.headers.startLoadingTime")}
                                dateValue={timetableStore.actions[this.props.actionIndex].startLoadingDate}
                                onChangeDate={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setStartLoadingDate(newDate);
                                }}
                                hourValue={timetableStore.actions[this.props.actionIndex].startLoadingHour}
                                onChangeHour={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setStartLoadingHour(newDate);
                                }}
                            />
                            <DateAndTime
                                testId={`end-loading-time-${this.props.actionIndex}`}
                                dateLabel={i18n.t("timetable.headers.endLoadingTime")}
                                dateValue={timetableStore.actions[this.props.actionIndex].endLoadingDate}
                                onChangeDate={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setEndLoadingDate(newDate);
                                }}
                                hourValue={timetableStore.actions[this.props.actionIndex].endLoadingHour}
                                onChangeHour={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setEndLoadingHour(newDate);
                                }}
                            />
                            <DateAndTime
                                testId={`open-parking-time-${this.props.actionIndex}`}
                                dateLabel={i18n.t("timetable.headers.openParkingTime")}
                                dateValue={timetableStore.actions[this.props.actionIndex].openParkingDate}
                                onChangeDate={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setOpenParkingDate(newDate);
                                }}
                                hourValue={timetableStore.actions[this.props.actionIndex].openParkingHour}
                                onChangeHour={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setOpenParkingHour(newDate);
                                }}
                            />
                            <DropDown
                                label={i18n.t("timetable.headers.destinationPort")}
                                validatedValue={timetableStore.actions[this.props.actionIndex].destinationPortId}
                                items={this.portsToDropDownMap()}
                                testId={`destination-port-${this.props.actionIndex}`}
                                className="destination-port"
                                error={!Api.isSuccess(this.props.portsResponse) ? i18n.t("errorMessages.portsErrorSuffix") : ""}
                                reloadFunc={() => this.props.portsReload()}
                            />
                        </div>
                    </div>
                </div>
            </>);
    }

    public routesToDropDownMap() {
        const timetableStore = this.context.timetableStore as ITimetableStore;
        const routes = timetableStore.routes;

        return DropDownUtils.listToDropDownMap(routes);
    }

    public portsToDropDownMap() {
        const timetableStore = this.context.timetableStore as ITimetableStore;
        const ports = timetableStore.ports;

        if (!ports || !ports.length) {
            return [];
        }

        return DropDownUtils.listToDropDownMap(timetableStore.ports);
    }
}
